import { FC } from "react";

import { useMapLibreMissingStyleImages } from "./use-maplibre-missing-style-images";

/** Registers v6 `setMissingStyleImageResolver` before route arrow / trail-dot symbol layers mount. */
export const MapLibreMissingStyleImages: FC = () => {
  useMapLibreMissingStyleImages();
  return null;
};
